import { render, staticRenderFns } from "./exitConfig.vue?vue&type=template&id=04a43468&scoped=true&"
import script from "./exitConfig.vue?vue&type=script&lang=ts&"
export * from "./exitConfig.vue?vue&type=script&lang=ts&"
import style0 from "./exitConfig.vue?vue&type=style&index=0&id=04a43468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a43468",
  null
  
)

export default component.exports